import { useMutation } from '@tanstack/react-query';
import { postPartnerPanelLogin } from '../services/partners';

const PARTNER_ACCESS_DENIED_MESSAGE = 'Access denied. Partner privileges required.';

/** POST /admin/partner-login — verify partner session after Firebase auth. */
export const useVerifyPartnerSessionMutation = (options = {}) => {
  const { onSuccess, onError, ...restOptions } = options;

  return useMutation({
    mutationFn: async () => {
      const result = await postPartnerPanelLogin();
      if (!result.success || !result.data?.isPartner) {
        const error = new Error(result.message || PARTNER_ACCESS_DENIED_MESSAGE);
        error.panelResult = result;
        throw error;
      }
      return result.data;
    },
    onSuccess: async (data, variables, context) => {
      await onSuccess?.(data, variables, context);
    },
    onError: (error, variables, context) => {
      onError?.(error, variables, context);
    },
    ...restOptions,
  });
};
